/* eslint-disable */

import React from "react";
import InfoAlert from "../../ui/InfoAlert";
import { ReactComponent as Warning } from "../../assets/icons/warning--filled.svg";
import { BULK_UPLOAD_GENERAL_TRANSLATIONS } from "../../translations/util";

interface IProps {
  showReport: boolean;
  totalConnectionsCreated: number;
  totalConnections: number;
  totalErrors: number;
  fileName: string;
  moduleName: string;
  onClick: () => void;
}
const ErrorReportPanel = ({
  showReport,
  totalConnections,
  totalConnectionsCreated,
  totalErrors,
  fileName,
  moduleName,
  onClick,
}: IProps) => {
  const timeStamp = new Date(
    Date.now() - new Date().getTimezoneOffset() * 60000
  )
    .toISOString()
    .slice(0, -5);

  return (
    <div className="data-tabcontent data-card" data-cy="report-section">
      {(showReport && totalConnectionsCreated) ||
      (showReport && totalErrors) ? (
        <div>
          <h4 className="report-tab-title" data-cy="report-tab-title">
            {BULK_UPLOAD_GENERAL_TRANSLATIONS.ErrorTab.title}{" "}
          </h4>
          <div
            className="readonly-data upload-summary"
            data-cy="readonly-section"
          >
            <ul>
              <li className="" data-cy="readOnly-labelTexts">
                <div className="flex items-center">
                  <h5>
                    {
                      BULK_UPLOAD_GENERAL_TRANSLATIONS.ErrorTab.readOnlyData
                        .fileLabel
                    }
                  </h5>
                  <div className="data-content">
                    <span data-cy="fileName"> {fileName} </span>
                  </div>
                </div>
                <div className="flex items-center">
                  <h5>
                    {
                      BULK_UPLOAD_GENERAL_TRANSLATIONS.ErrorTab.readOnlyData
                        .timestampLabel
                    }
                  </h5>
                  <div className="data-content">
                    <span data-cy="timeStamp"> {timeStamp} </span>
                  </div>
                </div>
                <div className="flex items-center">
                  <h5>
                    {
                      BULK_UPLOAD_GENERAL_TRANSLATIONS.ErrorTab.readOnlyData
                        .totalRowsLabel
                    }
                  </h5>
                  <div className="data-content">
                    <span data-cy="totalConnections"> {totalConnections} </span>
                  </div>
                </div>
                <div className="flex items-center">
                  <h5>
                    {BULK_UPLOAD_GENERAL_TRANSLATIONS.ErrorTab.readOnlyData.handleTotalConnectionsCreatedLabel(
                      moduleName
                    )}
                  </h5>
                  <div className="data-content">
                    <span data-cy="totalConnectionsCreated">
                      {" "}
                      {totalConnectionsCreated}{" "}
                    </span>
                  </div>
                </div>
                {totalErrors > 0 ? (
                  <div className="flex items-center">
                    <div className="data-content">
                      <h5>
                        {"  "}
                        {
                          BULK_UPLOAD_GENERAL_TRANSLATIONS.ErrorTab.readOnlyData
                            .errorLabel
                        }
                      </h5>
                      <span data-cy="totalErrors"> {totalErrors}</span>
                    </div>
                  </div>
                ) : null}
              </li>
            </ul>
          </div>
          {totalErrors > 0 ? (
            <h5 className="instruction-text flex items-center mt-4">
              <Warning />
              <p className="download-text">
                {
                  BULK_UPLOAD_GENERAL_TRANSLATIONS.ErrorTab.readOnlyData
                    .downloadErrorReportInstructionText
                }{" "}
                <a
                  className="ml-1"
                  onClick={() => onClick()}
                  data-cy="download-error-report"
                >
                  {
                    BULK_UPLOAD_GENERAL_TRANSLATIONS.ErrorTab.readOnlyData
                      .downloadErrorLinkText
                  }{" "}
                </a>
              </p>
            </h5>
          ) : null}
        </div>
      ) : (
        <InfoAlert
          heading={BULK_UPLOAD_GENERAL_TRANSLATIONS.InfoAlert.header}
          subText={BULK_UPLOAD_GENERAL_TRANSLATIONS.InfoAlert.subHeader}
        />
      )}
    </div>
  );
};

export default ErrorReportPanel;
